<template>
	<div class="col-12 col-sm-6 col-lg-3">
		<label>Spells Known</label>
		<div class="input-group" v-for="(number, spellLevel) in spellsKnown" :key="`spells-known-${level}-${spellLevel}`">
			<div class="input-group-prepend">
				<span class="input-group-text">{{spellLevel | ordinal}}</span>
			</div>
			<input class="form-control" v-model.number="spellsKnown[spellLevel]" @change="updateSpellsKnown(spellLevel)"/>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'level',
	],
	computed: {
		spellsKnown: function() {
			return this.$store.state.Character.Levels[this.level].Spells.Known
		},
		spellsList: function() {
			return this.$store.state.Character.Levels[this.level].Spells.List
		}
	},
	methods: {
		updateSpellsKnown: function(spellLevel){
			var number = this.spellsKnown[spellLevel];
			var created = false;

			//add the list if it's undefined
			if(this.spellsList[spellLevel] == undefined){
				created = true;
				this.$set(this.spellsList, spellLevel, [])
			}

			/*eslint-disable-next-line no-console*/
			console.log("Spells Known Updated! ", 
				`Character Level: ${this.level}. `, 
				`Spell Level: ${spellLevel}. `, 
				`New Value: ${number}. `, 
				`Old Value: ${this.spellsList[spellLevel].length}. `,
				(created)?`Creating Spells Known List. `:`Not Creating Spells Known List. `,
				(number == 0)?`Removing Spells Known List. `:`Not Removing Spells Known List. `,
				(number > this.spellsList[spellLevel].length)?`Adding Spells Known. `:`Not Adding Spells Known. `,
				(number < this.spellsList.length)?`Subtracting Spells Known. `:`Not Subtracting Spells Known. `,
			)

			//increasing spells known
			if( number > this.spellsList[spellLevel].length ){
				for(let i = this.spellsList[spellLevel].length; i < number; i++){
					this.spellsList[spellLevel].push({Name:"",Link:""});
				}
			}

			//decreasing spells known
			if( number < this.spellsList.length ){
				for(let i = this.spellsList.length; i > number; i--){
					this.spellsList.pop();
				}
			}

			//if number is 0, remove the list
			if(number == 0){
				this.$delete(this.spellsList, spellLevel);
			}
		},
	},
	watch: {
		spellsKnown: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp', [
					{
						key: `Levels[${this.level}].Spells.Known`,
						val: value,
					}
				])
			}
		},
		spellsList: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp', [
					{
						key: `Levels[${this.level}].Spells.List`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>
.input-group-text {
	width: 3.75em;
}
</style>